/**
 * Link do projeto no Wrike, de onde o backend extrai o PIT.
 *
 * O formato é fechado porque a extração do PIT depende do `id=` da query: um
 * link em outro formato é aceito pelo campo e volta sem PIT, sem erro visível.
 */
export const WRIKE_PIT_REGEX = /^https:\/\/www\.wrike\.com\/open\.htm\?id=\d+$/;

export const WRIKE_PIT_PLACEHOLDER =
  "Ex: https://www.wrike.com/open.htm?id=4431130756";

export const WRIKE_PIT_ERRO_FORMATO =
  "Formato inválido. Use: https://www.wrike.com/open.htm?id=XXXXXXXXX";

/**
 * Checagem de formato pura, sem aparar espaços — é o valor exato que segue para
 * a API que precisa casar, e é quem chama que decide se apara antes.
 */
export const linkPitValido = (link: string): boolean =>
  WRIKE_PIT_REGEX.test(link);
